import { Component, OnInit } from '@angular/core';
import { HomeService } from '../services/home.service';
import { NotificationUpdateService } from '../services/notification-update.service';

@Component({
  selector: 'app-notifications',
  templateUrl: './notifications.component.html',
  styleUrls: ['./notifications.component.scss']
})
export class NotificationsComponent implements OnInit {
  allnoti: any[] = [];
  page: number = 1;
  noData: boolean = true;
  unreadCount: number = 0;
  
  constructor(
    private home: HomeService,
    private notificationUpdateService: NotificationUpdateService
  ) { }
  
  ngOnInit(): void {
    this.readNoti();
    this.getNotification();
  }
  
  getNotification() {
    this.home.getNotification().subscribe((res: any) => {
      console.log('Notification response:', res);
      this.allnoti = res.notifications || [];
      this.unreadCount = res.unreadLength || 0;
      
      if (this.allnoti && this.allnoti.length > 0) {
        this.noData = false;
      } else {
        this.noData = true;
      }
    });
  }
  
  // readNoti() {
  //   this.home.notificationRead().subscribe((res: any) => {
  //     console.log('Mark as read response:', res);
      
  //     // Refresh notifications
  //     this.getNotification();
      
  //     // Notify header to update count
  //     this.notificationUpdateService.notifyNotificationRead();
  //   });
  // }
//   readNoti() {
//   this.home.notificationRead().subscribe((res: any) => {
//     console.log(res);

//     this.notificationUpdateService.notifyNotificationRead();
//     this.getNotification();
//   });
// }
readNoti() {
  this.home.notificationRead().subscribe((res: any) => {
    console.log(res);

    // Header refresh
    this.notificationUpdateService.notifyNotificationRead();

    // Refresh notification list
    this.getNotification();
  });
}
  // Method to display the correct label based on conditions
  getDisplayValue(not: any): string {
    if (!not?.order_id) {
      if (not?.status === 'Rate Matched' || not?.status === 'Price Decreased') {
        return 'Rate Alert';
      } else if (
        not?.status === 'kyc Approved' ||
        not?.status === 'kyc Pending' ||
        not?.status === 'kyc Rejected'
      ) {
        return 'KYC';
      }
    }
    return not?.order_id || '';
  }
  
  // Helper method to check if order_id exists
  hasOrderId(not: any): boolean {
    return not && not.order_id && not.order_id.trim() !== '';
  }
  
  // Helper method to get display type
  getDisplayType(not: any): string {
    if (!not?.order_id) {
      if (not?.status === 'Rate Matched' || not?.status === 'Price Decreased') {
        return 'Rate Alert';
      } else if (
        not?.status === 'kyc Approved' ||
        not?.status === 'kyc Pending' ||
        not?.status === 'kyc Rejected'
      ) {
        return 'KYC';
      }
    }
    return 'Order';
  }
  
  // Get count of unread notifications
  getUnreadCount(): number {
    return this.allnoti.filter(not => !not.read).length;
  }
}